module.exports = __webpack_public_path__ + "media/components/slider/s8-806c7437e08fcdd11a4dd878b4d6b0a3.jpg";